// Performance.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Performance() {
    return (
        <PageLayout title="Performance" subtitle="Performance overview">
            <div className="container flex col box-container">
                {/* <div className="box">Performance</div> */}
            </div>
        </PageLayout>   
    );
}

export default Performance;
